export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export const DATE_INPUT_FORMAT = { year: 'numeric', month: '2-digit', day: 'numeric' };
export const WEEKDAY_FORMAT = 'ccc';
